<template>
  <div class="interactives-dropdown-input">
    <label v-if="inputData.label" :for="inputData.name">{{ inputData.label }}</label>
    <select
      :name="inputData.name"
      v-model="value"
    >
        <option v-if="inputData.placeholder" disabled value="">{{ inputData.placeholder }}</option>
        <option v-for="option in inputData.options"
            :value="option.value !== undefined ? option.value : option.label"
        >{{ option.label }}</option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'interactives-dropdown-input',
  props: ['inputData'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    value: function (newValue) { this.inputData.value = newValue }
  }
}
</script>

<style>
.interactives-text-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/Dropdown.vue